<div class="px-2 selectAreaContainer">
    <org-sys-area-tree [orgSysAreaService]="service" [filterToActive]="true"></org-sys-area-tree>
</div>
